import styled from 'styled-components';
import { spacing, body2, colors } from 'ui/theme';
import { FormField } from 'ui/formField';

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacing.base};
  margin-bottom: ${spacing.base};
`;

export const FormFieldWithoutMargin = styled(FormField)`
  &&& {
    margin-top: 0;
  }
`;

export const CheckboxDescription = styled.p<{ isDisabled?: boolean }>`
  ${body2}
  cursor: default;
  grid-area: content;
  ${(props) => (props.isDisabled ? `color: ${colors.textDisabled};` : '')}
`;

export const CheckboxRows = styled.div`
  display: grid;
  gap: 8px;
`;

export const CheckboxRow = styled.div`
  display: flex;
  & > *:first-child {
    margin-right: ${spacing.half};
    margin-top: ${spacing.quarter};
  }
`;
